














import VueOptions from '@utils/VueOptions'

settings =
  name: 'OfferShow'
  # components: { Modal }
  resources:
    team: 
      resourceName: "team"
      slug: "team"
  vue:
    computed:
      hello: -> 'world'
    data: ->
      foo: 'bar'
    methods:
      hi: -> 
export default VueOptions.vue settings

